import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-m',
    templateUrl: './m.component.html',
    styleUrls: ['./m.component.scss'],
})
export class MComponent {
    tooltip_position = 'above';
    @Input() form: UntypedFormGroup;
}
